import React, { useContext } from 'react';
import { TooltipPopper } from '../../Tooltip';
import { DropdownStateContext } from '../DropdownStateManager';
var PopperDropdownContent = function (_a) {
    var usePortal = _a.usePortal, _b = _a.placement, placement = _b === void 0 ? 'bottom-end' : _b, children = _a.children;
    var _c = useContext(DropdownStateContext), isOpen = _c.isOpen, setMenuRef = _c.setMenuRef;
    return (React.createElement(TooltipPopper, { isOpen: isOpen, usePortal: usePortal, positionOnly: true, placement: placement, innerRef: setMenuRef }, children));
};
PopperDropdownContent.displayName = 'PopperDropdownContent';
export default PopperDropdownContent;
//# sourceMappingURL=PopperDropdownContent.js.map